import { internal } from '../../vendor/elix.js';

function FocusableMixin(Base) {

  return class Focusable extends Base {

    static get observedAttributes() {
      return [
        ...super.observedAttributes,
        'autofocus'
      ];
    }

    constructor() {
      super();
      this.addEventListener('focus', () => this[internal.setState]({ focused: this.disabled ? false : true }));
      this.addEventListener('blur', () => this[internal.setState]({ focused: false }));
    }

    get [internal.defaultState]() {
      return Object.assign(
        {},
        super[internal.defaultState],
        { autofocus: false, focused: false }
      );
    }

    attributeChangedCallback(attributeName, oldValue, newValue) {
      super.attributeChangedCallback(attributeName, oldValue, newValue);
      if (attributeName === 'autofocus') {
        this.autofocus = newValue;
      }
    }

    get autofocus() {
      return this[internal.state].autofocus;
    }

    set autofocus(autofocus) {
      const hasAutofocus = autofocus === true || autofocus === 'true' || this.hasAttribute('autofocus');
      this[internal.setState]({ autofocus: hasAutofocus });
    }

    [internal.render](changed) {

      super[internal.render](changed);

      if (changed.autofocus) {
        this.renderAutoFocus();
      }

      if (changed.focused) {
        this.renderFocusedState();
      }

    }

    renderAutoFocus() {
      const inner = this.shadowRoot.querySelector(this.innerSelector || '#inner');
      if (inner) {
        inner.autofocus = this.autofocus;
      }
    }

    renderFocusedState() {
  
      const inputStateContainer = this.shadowRoot.querySelector('.inputStateContainer');

      if (inputStateContainer) {
        if (this[internal.state].focused) {
          inputStateContainer.classList.add('focused');
        } else {
          inputStateContainer.classList.remove('focused');
        }
      }

    }

  }
}

export default FocusableMixin;
